import { render, staticRenderFns } from "./XdocView.vue?vue&type=template&id=9aac198e&scoped=true&"
import script from "./XdocView.vue?vue&type=script&lang=js&"
export * from "./XdocView.vue?vue&type=script&lang=js&"
import style0 from "./XdocView.vue?vue&type=style&index=0&id=9aac198e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aac198e",
  null
  
)

export default component.exports